import { useNavigate } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { useColumnsInstalacionesOT } from '@/erp/tecnico/orden-trabajo/shared/hooks';
import {
  EstadosActivacionInstallOTEnumChoice,
  EstadosOrdenTrabajoEnumChoice,
  ROUTER_PATHS,
  TABLE_CONSTANTS,
  hasAllPermissions,
  useCheckPermissions,
  useTableFilter,
  useTableServerSideFiltering,
} from '@/shared';
import { useFetchOrdenTrabajos } from '@/shared/actions/erp';
import {
  CustomSearch,
  GeneralTable,
  LoaderComponent,
  SingleTableBoxScene,
} from '@/shared/components/ui';
import { OrdenTrabajo } from '@/shared/interfaces';
import { useFlotasStore } from '@/store/erp';

export const cambiosPendientesOTActivacionUrl =
  ROUTER_PATHS.operaciones.activacionInstallCambioPuertoNav;

export interface ActivacionesPrerechazadasProps {}

const CambiosPendientesOTActivacion: React.FC<
  ActivacionesPrerechazadasProps
> = () => {
  useCheckPermissions(PermissionsEnum.api_view_ordentrabajo);

  const navigate = useNavigate();

  ///* global state
  const isLoadingFlotas = useFlotasStore(s => s.isLoadingFlotas);

  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  ///* fetch data
  const {
    data: ordenTrabajoPendienteActivacionPaging,
    isLoading,
    isRefetching,
  } = useFetchOrdenTrabajos({
    enabled: true,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      identificacion: searchTerm,
      ...filterObject,
      filterByState: false,
      estado_orden_trabajo: EstadosOrdenTrabajoEnumChoice.EN_ESPERA,
      estado_activacion:
        EstadosActivacionInstallOTEnumChoice.PENDIENTE_CAMBIO_PUERTO,
    },
  });

  ///* actions
  const onEdit = (original: OrdenTrabajo) => {
    navigate(
      `${cambiosPendientesOTActivacionUrl}/${original?.id_orden_trabajo}`
    );
  };

  ///* columns
  const { instalacionesActivacionRealizadaColumns } =
    useColumnsInstalacionesOT();

  if (isLoadingFlotas) return <LoaderComponent />;

  return (
    <SingleTableBoxScene
      title="Solicitudes de Cambio de NAP/Puerto Pendientes"
      enableRedirect={false}
    >
      <CustomSearch
        onChange={onChangeFilter}
        value={globalFilter}
        text="por identificación cliente"
      />

      <GeneralTable<OrdenTrabajo>
        columns={instalacionesActivacionRealizadaColumns}
        data={ordenTrabajoPendienteActivacionPaging?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // filters - server side
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={ordenTrabajoPendienteActivacionPaging?.data?.count}
        // // actions ========
        enableColumnActions={hasAllPermissions([
          PermissionsEnum.api_change_ordentrabajo,
        ])}
        enableEditing={hasAllPermissions([
          PermissionsEnum.api_change_ordentrabajo,
        ])}
        actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
        // crud
        canEdit={hasAllPermissions([PermissionsEnum.api_change_ordentrabajo])}
        onEdit={onEdit}
        canDelete={false}
      />
    </SingleTableBoxScene>
  );
};

export default CambiosPendientesOTActivacion;
